import { createContext, useContext } from 'react';

export const PopoverCloseContext = createContext<() => void>(() => {});

/** Close the popover that wraps this control. */
export const usePopoverClose = () => useContext(PopoverCloseContext);
